module.exports = __webpack_public_path__ + "images/landing/banner/help-img-6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/banner/help-img-6.png
// module id = KLLA
// module chunks = 154